// Example GraphQL queries and mutations for your application
import { gql } from '@apollo/client';

// Query - Get bank transactions with matched rules
export const GET_BANK_TRANSACTIONS = gql`
  query BankTransactions($input: BankTransactionsInput!, $bookId: ID!) {
    book(bookId: $bookId) {
      bankTransactions(input: $input) {
        transactionId
        matchedRule {
          id
          contactId
          bankTransferBankAccountId
          sortOrder
          ruleName
          transactionRuleType
          allocationRuleType
          allocationRuleDescription
          allocationRulesDetails {
            amount
            percentage
            account {
                accountCode     
            }
        }
        }
      }
    }
  }
`;

// Mutation - Allocate rule matched transaction
export const ALLOCATE_RULE_MATCHED_TRANSACTION = gql`
  mutation AllocateRuleMatchedTransaction($input: AllocateRuleMatchedTransactionsInput) {
    allocateRuleMatchedTransaction(input: $input) {
      allocationResults {
        errorMessage
        isSuccess
        transactionId
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries.js